@if (isFetching()) {
  <div class="loading">Chargement…</div>
}

@if (!isFetching()) {
  <div class="fiche-container animate-fade-in">

    <!-- Header -->
    <div class="fiche-titlebar grid grid-cols-3 items-center pt-4 px-2 md:px-4">
      <div class="justify-self-start">
        <button (click)="onCancel()" class="flex items-center gap-2 text-stone-400 hover:text-primary-600 transition-colors cursor-pointer">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
          <span class="text-[11px] font-bold uppercase tracking-wider">Retour aux actualités</span>
        </button>
      </div>
      <div class="justify-self-center">
        <h1 class="page-title">{{ pageTitle }}</h1>
      </div>
      <div class="justify-self-end"></div>
    </div>

    @if (errorMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-red-50 border border-red-100 text-sm text-red-700 flex items-center gap-3">
        <span class="material-icons text-base text-red-500">error_outline</span>
        {{ errorMessage() }}
      </div>
    }
    @if (successMessage()) {
      <div class="mx-2 p-4 rounded-2xl bg-emerald-50 border border-emerald-100 text-sm text-emerald-700 flex items-center gap-3">
        <span class="material-icons text-base text-emerald-500">check_circle</span>
        {{ successMessage() }}
      </div>
    }

    <form (ngSubmit)="onSave()">
      <div class="fiche-content-area space-y-6">

        <!-- Image -->
        <div class="fiche-section">
          <div class="fiche-section-title">Image de l'article</div>
          <div class="fiche-section-box flex flex-col items-center p-6 gap-3">
            <div class="relative w-full sm:w-auto">
              <label class="cursor-pointer block">
                <div class="w-[560px] max-w-full h-48 rounded-xl bg-stone-100 border-2 border-dashed border-stone-300 hover:border-primary-400 hover:bg-stone-50 transition-all flex items-center justify-center overflow-hidden">
                  @if (imagePreview()) {
                    <img [src]="imagePreview()!" alt="Aperçu" class="w-full h-full object-cover" />
                  } @else {
                    <div class="flex flex-col items-center gap-2 text-stone-400">
                      <svg class="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                      </svg>
                    </div>
                  }
                </div>
                <input type="file" accept=".jpg,.jpeg,.webp" class="hidden" (change)="onFileSelected($event)" />
              </label>
              @if (imagePreview()) {
                <button type="button" (click)="removeImage()"
                  class="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 hover:bg-red-600 text-white flex items-center justify-center shadow-md transition-colors">
                  <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                  </svg>
                </button>
              }
            </div>
            <p class="text-xs text-stone-400">JPG, WEBP · 1280×720px max · Format 16:9 · Max 5 Mo</p>
          </div>
        </div>

        <!-- Informations -->
        <div class="fiche-section">
          <div class="fiche-section-title">Informations de l'article</div>
          <div class="fiche-section-box">
            <div class="fiche-grid">

              <div class="fiche-field">
                <span class="fiche-label-fixed">Titre <span class="text-red-500">*</span></span>
                <input type="text"
                  [value]="formData().news_name"
                  (input)="updateField('news_name', $any($event.target).value)"
                  maxlength="255" placeholder="Titre de l'actualité"
                  autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Tags</span>
                <app-tag-input module="NEWS" [value]="formData().news_tags || ''" (valueChange)="updateField('news_tags', $event)"></app-tag-input>
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Auteur</span>
                <input type="text"
                  [value]="formData().news_author || ''"
                  (input)="updateField('news_author', $any($event.target).value)"
                  placeholder="Auteur (optionnel)" autoDir class="fiche-input" />
              </div>

              <div class="fiche-field">
                <span class="fiche-label-fixed">Date <span class="text-red-500">*</span></span>
                <input type="date"
                  [value]="formData().news_begin_date"
                  (input)="updateField('news_begin_date', $any($event.target).value)"
                  autoDir class="fiche-input" />
              </div>


            </div>
          </div>
        </div>

        <!-- Résumé -->
        <div class="fiche-section">
          <div class="fiche-section-title">Résumé</div>
          <div class="fiche-section-box">
            <div class="fiche-field full-width">
              <span class="fiche-label-fixed">Extrait</span>
              <textarea [value]="formData().news_excerpt || ''"
                (input)="updateField('news_excerpt', $any($event.target).value)"
                placeholder="Court résumé affiché dans la liste (optionnel)"
                rows="2" maxlength="500"
                autoDir class="fiche-input resize-none"></textarea>
            </div>
          </div>
        </div>

        <!-- Contenu — WordPress-style editor -->
        <div class="fiche-section">
          <div class="fiche-section-title">Contenu <span class="text-red-500">*</span></div>

          <div class="border border-stone-200 rounded-2xl overflow-hidden bg-white shadow-sm">

            <!-- Tab + Toolbar row -->
            <div class="flex items-center bg-stone-50 border-b border-stone-200">

              <!-- Tabs -->
              <button type="button" (click)="setEditorMode('visual')"
                class="px-4 py-2.5 text-xs font-bold uppercase tracking-wider border-b-2 transition-all"
                [class.border-primary-500]="editorMode() === 'visual'"
                [class.text-stone-800]="editorMode() === 'visual'"
                [class.bg-white]="editorMode() === 'visual'"
                [class.border-transparent]="editorMode() !== 'visual'"
                [class.text-stone-400]="editorMode() !== 'visual'">
                Aperçu
              </button>
              <button type="button" (click)="setEditorMode('code')"
                class="px-4 py-2.5 text-xs font-bold uppercase tracking-wider border-b-2 transition-all"
                [class.border-primary-500]="editorMode() === 'code'"
                [class.text-stone-800]="editorMode() === 'code'"
                [class.bg-white]="editorMode() === 'code'"
                [class.border-transparent]="editorMode() !== 'code'"
                [class.text-stone-400]="editorMode() !== 'code'">
                Code
              </button>

              <!-- Formatting toolbar — Aperçu mode only -->
              @if (editorMode() === 'visual') {
                <div class="flex items-center gap-0.5 ml-3 pl-3 border-l border-stone-200">

                  <button type="button" (click)="execFormat('bold')" title="Gras"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-sm font-bold">B</button>

                  <button type="button" (click)="execFormat('italic')" title="Italique"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-sm italic">I</button>

                  <button type="button" (click)="execFormat('underline')" title="Souligné"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-sm underline">U</button>

                  <button type="button" (click)="execFormat('strikeThrough')" title="Barré"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-sm line-through">S</button>

                  <div class="w-px h-4 bg-stone-300 mx-1"></div>

                  <button type="button" (click)="insertHeading('h2')" title="Titre H2"
                    class="px-2 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-[11px] font-bold">H2</button>

                  <button type="button" (click)="insertHeading('h3')" title="Sous-titre H3"
                    class="px-2 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-[11px] font-bold">H3</button>

                  <button type="button" (click)="insertParagraph()" title="Paragraphe"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors text-sm font-serif">P</button>

                  <div class="w-px h-4 bg-stone-300 mx-1"></div>

                  <button type="button" (click)="execFormat('insertUnorderedList')" title="Liste à puces"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                    </svg>
                  </button>

                  <button type="button" (click)="execFormat('insertOrderedList')" title="Liste numérotée"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" />
                    </svg>
                  </button>

                  <button type="button" (click)="insertLink()" title="Insérer un lien"
                    class="w-7 h-7 flex items-center justify-center text-stone-600 hover:bg-stone-200 rounded transition-colors">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                    </svg>
                  </button>

                  <div class="w-px h-4 bg-stone-300 mx-1"></div>

                  <button type="button" (click)="execFormat('removeFormat')" title="Effacer la mise en forme"
                    class="w-7 h-7 flex items-center justify-center text-stone-400 hover:bg-stone-200 hover:text-stone-600 rounded transition-colors">
                    <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>

                </div>
              }
            </div>

            <!-- VISUAL (Aperçu) — contenteditable WYSIWYG -->
            @if (editorMode() === 'visual') {
              <div
                #visualEditor
                autoDir
                contenteditable="true"
                (input)="onVisualInput()"
                class="prose w-full px-5 py-4 min-h-[280px] outline-none text-stone-800 text-sm leading-relaxed"
                style="white-space: pre-wrap;"
              ></div>
            }

            <!-- CODE — raw HTML textarea -->
            @if (editorMode() === 'code') {
              <textarea
                autoDir
                [value]="formData().news_content"
                (input)="onCodeInput($event)"
                placeholder="HTML du contenu…"
                rows="16"
                spellcheck="false"
                class="w-full px-4 py-3 text-sm font-mono text-stone-700 bg-stone-950 text-emerald-400 border-0 outline-none resize-y leading-relaxed"
                style="min-height: 280px; tab-size: 2; background:#1e1e2e; color:#cdd6f4;"
              ></textarea>
            }

          </div>

          <p class="text-[11px] text-stone-400 mt-1 ml-1">
            Aperçu = éditeur visuel · Code = HTML brut
          </p>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-3 pt-2">
          <button type="button" (click)="onCancel()" [disabled]="isLoading()"
            class="px-5 py-2.5 border border-stone-200 text-stone-600 rounded-xl hover:bg-stone-50 disabled:opacity-50 transition-colors text-sm font-medium">
            Annuler
          </button>
          <button type="submit" [disabled]="isLoading()"
            class="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600 text-white rounded-xl hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-semibold shadow-sm shadow-primary-600/10">
            @if (isLoading()) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            } @else {
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
              </svg>
            }
            {{ isLoading() ? 'Enregistrement…' : 'Enregistrer' }}
          </button>
        </div>

      </div>
    </form>
  </div>
}
